module.exports = __webpack_public_path__ + "static/media/Salesforce.ae52848b.png";